import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CommandStatus } from '../api/api-reference';
import { SignalRService } from './signalr.service';

export interface OnDemandReadClientResponse {
  commandId: string;
  meterId: string;
  meterNumber: string;
  commandStatus: CommandStatus;
  status: boolean;
  errorMessage?: string;
  serializedValues?: string;
  meterIsOnline?: boolean;
}

/**
 * Owns the single 'reads-on-demand' hub handler and fans results out over rxjs.
 * SignalRService keeps only one handler per event name, so components must not
 * register 'reads-on-demand' themselves - they subscribe to results$ instead.
 */
@Injectable({ providedIn: 'root' })
export class OnDemandReadStateService {
  private readonly notificationPath = '/notification';
  private readonly eventName = 'reads-on-demand';

  private readonly results = new Subject<OnDemandReadClientResponse>();
  readonly results$: Observable<OnDemandReadClientResponse> = this.results.asObservable();

  constructor(private signalRService: SignalRService) {}

  // Safe to call from every consumer: re-registering our own callback replaces it with itself.
  async ensureSubscribed(): Promise<void> {
    try {
      await this.signalRService.startNewConnection(this.notificationPath);
      this.signalRService.registerHandler(
        this.notificationPath,
        this.eventName,
        (message: OnDemandReadClientResponse) => this.results.next(message),
      );
    } catch (error) {
      console.error('[OnDemandReadState] Failed to subscribe to reads-on-demand events:', error);
    }
  }
}
